import { ALL_ASPECT_RATIOS } from '../aspectRatioConfig';
import { METRIC_NAME_MAPPING } from './metrics';

/**
 * Validates that a given set of label values match the expected keys and
 * label value of the the given metric
 */
export function validateLabelsAndName(metricName: string, labels: Record<string, string>): boolean {
    const metricDefn = METRIC_NAME_MAPPING[metricName];
    if (!metricDefn) {
        console.error(`Unknown metric name: ${metricName}`);
        return false;
    }

    for (const labelName in metricDefn.labelValueMapping) {
        if (typeof labels[labelName] === 'undefined') {
            return false;
        }
        const actualValue = labels[labelName];
        const expectedValues = metricDefn.labelValueMapping[labelName];
        if (!expectedValues.includes(actualValue)) {
            return false;
        }
    }
    return true;
}

export const VALID_RESOLUTIONS = {
    SMALL: '1-480',
    MEDIUM: '481-720',
    LARGE: '721-1080',
    XL: '> 1080',
};

/**
 * @param resolution luminary._resolutionValue property
 */
export function formatResolution(resolution: number): string {
    if (resolution >= 1 && resolution <= 480) {
        return VALID_RESOLUTIONS.SMALL;
    }
    if (resolution >= 481 && resolution <= 720) {
        return VALID_RESOLUTIONS.MEDIUM;
    }
    if (resolution >= 721 && resolution <= 1080) {
        return VALID_RESOLUTIONS.LARGE;
    }
    return VALID_RESOLUTIONS.XL;
}

export const VALID_SLIDE_COUNTS = {
    ONE_TO_TEN: '1-10',
    ELEVEN_TO_TWNETY: '11-20',
    TWENTY_ONE_TO_THIRTY: '21-30',
    THIRTY_ONE_TO_FORTY: '31-40',
    FORTY_PLUS: '40+',
};

/**
 * @param slideCount luminary.scenes.length
 */
export function formatSlideCount(slideCount: number): string {
    if (slideCount <= 10) {
        return VALID_SLIDE_COUNTS.ONE_TO_TEN;
    }
    if (slideCount > 10 && slideCount <= 20) {
        return VALID_SLIDE_COUNTS.ELEVEN_TO_TWNETY;
    }
    if (slideCount > 20 && slideCount <= 30) {
        return VALID_SLIDE_COUNTS.TWENTY_ONE_TO_THIRTY;
    }
    if (slideCount > 30 && slideCount <= 40) {
        return VALID_SLIDE_COUNTS.THIRTY_ONE_TO_FORTY;
    }
    return VALID_SLIDE_COUNTS.FORTY_PLUS;
}

export const VALID_ASPECT_RATIOS = ALL_ASPECT_RATIOS;
